import { render, staticRenderFns } from "./CopyOrder.vue?vue&type=template&id=9bc30c02&scoped=true"
import script from "./CopyOrder.vue?vue&type=script&lang=js"
export * from "./CopyOrder.vue?vue&type=script&lang=js"
import style0 from "./CopyOrder.vue?vue&type=style&index=0&id=9bc30c02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc30c02",
  null
  
)

export default component.exports